import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetImagesAndRemarksSection, WorksheetRootComponent, WorksheetTestedBySection } from '../../Core';
import qestIds from '../../QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from './Sections';

let DynamicConePenetrometerWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>
      <PageSection heading="Measurements">
        <MeasurementsSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

DynamicConePenetrometerWorksheet = withInjectedProps(DynamicConePenetrometerWorksheet);
DynamicConePenetrometerWorksheet.qestIds = [qestIds.dynamicConePenetrometer.InHouseMethod];

export default DynamicConePenetrometerWorksheet;
export { DynamicConePenetrometerWorksheet };
